import { render, staticRenderFns } from "./ChartLabel.vue?vue&type=template&id=338dcbe9&scoped=true"
import script from "./ChartLabel.vue?vue&type=script&lang=js"
export * from "./ChartLabel.vue?vue&type=script&lang=js"
import style0 from "./ChartLabel.vue?vue&type=style&index=0&id=338dcbe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338dcbe9",
  null
  
)

export default component.exports